export default class AsyncRenderer {

  constructor($view){
    this.$view = $view;
    this.url = this.$view.data('url');
    this.refresh();
  }

  refresh(){
    Api.GET(this.url);
  }

}